export default "__VITE_ASSET__2bcaf51c__"